import * as React from 'react';

import { UitkIcon } from 'uitk-react-icons';
import { AmenityViewModel } from 'models';
import { addIcon } from 'utils/amenity-mapper';

interface AmenitiesCarouselProps {
  amenities: AmenityViewModel[];
}

export const AmenitiesCarousel: React.FunctionComponent<AmenitiesCarouselProps> = ({ amenities }) => (
  <ul className="pwa-theme--grey-700 amenities__list-items">
    {amenities.map((amenityWithoutIcon, index) => {
      const amenity = addIcon(amenityWithoutIcon);
      const amenityDescription = amenity.description;
      const amenityIcon = amenity.icon;

      return (
        <li className="amenities__list-item" key={`amenity-${index}-${amenityDescription}`}>
          <div aria-hidden="true">
            <UitkIcon id={`amenity-icon-${amenityIcon}`} name={amenityIcon} title={amenityDescription} />
            <span className="uitk-type-100 amenities-icon-description">{amenityDescription}</span>
          </div>
          <span className="is-visually-hidden">{amenityDescription}</span>
        </li>
      );
    })}
  </ul>
);
